var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_753","data-name":"Path 753","d":"M-7537.826-10887.471l4,4-4,4","transform":"translate(7538.18 10887.824)","fill":"none","stroke":"#9b9ea5","strokeWidth":"1"}));
}

ArrowRight.defaultProps = {"width":"5.061","height":"8.707","viewBox":"0 0 5.061 8.707"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
